/**
 * Utility function checking if current runtime is inside Cypress test environment.
 * returns True when executed in Cypress, false otherwise.
 */
export function isRunningInsideCypress(): boolean {
  return typeof Cypress !== 'undefined';
}
